(function() {
	'use strict';
	var $ = avm.require('cash'),
		$show = $('.js-show'),
		$close = $('.js-hide');

	$show.on('click', function() {
		var $target = $(this).parents('.media-text').find('.js-hidden');

		$target.addClass('d-block');
		$(this).addClass('d-none');
	});

	$close.on('click', function() {
		var $target = $(this).parents('div'),
			$showButton = $target.find('.js-show');

		$showButton.removeClass('d-none');
		$target.removeClass('d-block');
	});
})();
